import { createContext, useContext, useEffect, useState } from "react";
import it from "./it";
import en from "./en";
import ru from "./ru";
import ar from "./ar";

const DICTS = { it, en, ru, ar };
export const LANGS = [
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
  { code: "ru", label: "RU" },
  { code: "ar", label: "AR" },
];

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem("lcp_lang");
    return DICTS[saved] ? saved : "it";
  });

  useEffect(() => {
    localStorage.setItem("lcp_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = (key) => DICTS[lang]?.[key] ?? it[key] ?? key;

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLang = () => useContext(LangContext);
